import React, { useState } from 'react'
import { firestore } from '../../../firebase';
import ImagePickerReturnUrl from '../Media/templates/ImagePickerReturnUrl';

function AddTransfer() {

    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [transferSum, setTransferSum] = useState(0);

    const [toClubName, setToClubName] = useState("");
    const [fromClubName, setFromClubName] = useState("");
    const [fromClubId, setFromClubId] = useState("");
    const [toClubId, setToClubId] = useState("");

    const [fromLeagueId, setFromLeagueId] = useState("");
    const [toLeagueId, setToLeagueId] = useState("");

    const [show, setShow] = useState(false)

    const [date, setDate] = useState("");
    const [message, setMessage] = useState("");

    async function addTransferHandler(e) {
        e.preventDefault();
        try {
            const transferRef = firestore.collection("transfers");
            const transferData = {
                player_name: name,
                image,
                transfer_sum: +transferSum,
                from_club_name: fromClubName,
                to_club_name: toClubName,
                from_club: fromClubId,
                to_club: toClubId,
                to_league_id: toLeagueId,
                from_league_id: fromLeagueId,
                date

            }
            transferRef.add(transferData)
            setMessage("Lagt til!")
        } catch (error) {
            setMessage(error.message)
        }
    }

    return (
        <div className="container my-4">
            <form onSubmit={addTransferHandler}>

                <label>Spiller navn</label>
                <input value={name} onChange={e => setName(e.target.value)} className="form-control mb-2" placeholder="Spillers navn" />

                <label>Bilde</label>
                <input value={image} onChange={e => setImage(e.target.value)} className="form-control mb-2" />
                

                {image && <img style={{maxWidth: "500px"}} src={image} className="img-fluid" alt="" />}
                <div className="btn btn-success btn-block" style={{cursor: "pointer"}} onClick={() => setShow(true)}>Velg bilde url</div>

                <label>Dato for overgang</label>
                <input type="date" className="form-control mb-2" value={date} onChange={e => setDate(e.target.value)} />

                <label>Overgangssum</label>
                <input type="number" value={transferSum} onChange={e => setTransferSum(e.target.value)} className="form-control mb-2" />

                <label>Fra klubb navn:</label>
                <input value={fromClubName} onChange={e => setFromClubName(e.target.value)} className="form-control mb-2" placeholder="Fra klubb navn" />
                <label>Til klubb navn</label>
                <input value={toClubName} onChange={e => setToClubName(e.target.value)} className="form-control mb-2" placeholder="Til klubb navn" />

                <label>Fra klubb id</label>
                <input value={fromClubId} onChange={e => setFromClubId(e.target.value)} className="form-control mb-2" placeholder="Fra klubb id" />
                <label>Til klubb id</label>
                <input value={toClubId} onChange={e => setToClubId(e.target.value)} className="form-control mb-2" placeholder="Til klubb id" />

                <label>Fra liga ID</label>
                <input value={fromLeagueId} onChange={e => setFromLeagueId(e.target.value)} className="form-control mb-2" placeholder="Fra liga ID" />
                <label>Til liga ID</label>
                <input value={toLeagueId} onChange={e => setToLeagueId(e.target.value)} className="form-control mb-2" placeholder="Til liga ID" />

                {message && <div className="alert alert-success">{message}</div>}
                <button className="btn btn-primary btn-rounded">Legg til</button>

            </form>
            <ImagePickerReturnUrl show={show} setShow={setShow} imageUrl={image} setImageUrl={setImage} />
        </div>
    )
}
export default AddTransfer